/**
 * Raios (m) de uma parada na roteirização, num sentido (ida/volta). Cada raio é resolvido
 * sozinho, nesta ordem:
 * 1. o da própria parada (CSV ou digitado no diálogo de parada);
 * 2. o dos turnos que casam com a parada, no sentido (`raio_*_ida` / `raio_*_volta`), o menor;
 * 3. o global da tela de Configurações (`radiusConfig.ideal` / `radiusConfig.max`).
 * PCD é sempre buscado em casa: não tem raio, seja qual for o turno.
 *
 * `getTurnos` é chamado só quando a parada não tem algum dos raios (casar turno custa).
 *
 * @param {Object} stop
 * @param {{ sentido?: 'ida'|'volta', getTurnos?: () => Object[], radiusConfig?: { ideal?: number, max?: number } }} opts
 * @returns {{ raio_ideal: number|null, raio_maximo: number|null }}
 */
export function resolverRaiosParada(stop, { sentido = 'ida', getTurnos = () => [], radiusConfig = {} } = {}) {
    if (!stop || Number(stop.pcd) === 1) return { raio_ideal: null, raio_maximo: null };
    const positive = (n) => n != null && n !== '' && Number.isFinite(Number(n)) && Number(n) > 0;
    const suffix = sentido === 'volta' ? 'volta' : 'ida';
    let turnos = null;
    const resolve = (field, globalValue) => {
        if (positive(stop[field])) return Number(stop[field]);
        if (turnos == null) turnos = getTurnos() || [];
        const fromTurnos = turnos
            .map((t) => t && t[`${field}_${suffix}`])
            .filter(positive)
            .map(Number);
        if (fromTurnos.length) return Math.min(...fromTurnos);
        return positive(globalValue) ? Number(globalValue) : null;
    };
    const cfg = radiusConfig || {};
    const raio_maximo = resolve('raio_maximo', cfg.max);
    let raio_ideal = resolve('raio_ideal', cfg.ideal);
    // O raio ideal nunca pode passar do máximo: o passe "ideal" aceitaria caminhada acima dele.
    if (raio_ideal != null && raio_maximo != null && raio_ideal > raio_maximo) raio_ideal = raio_maximo;
    return { raio_ideal, raio_maximo };
}
